import { render } from "./esco-ativar-conta.vue?vue&type=template&id=1ccb2e66&scoped=true"
import script from "./esco-ativar-conta.vue?vue&type=script&lang=js"
export * from "./esco-ativar-conta.vue?vue&type=script&lang=js"

import "./esco-ativar-conta.vue?vue&type=style&index=0&id=1ccb2e66&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccb2e66"]])

export default __exports__